import { Component } from "react"

/* Components */
import { InnerLayout, Pagination } from "../../components"

/* Modal */
import Modal from "react-modal"

/* REST API */
import { refunds } from "../../api/Table"

/* Helpers */
import { utils } from "../../helpers"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"



/* Widget Refunds */
class Refunds extends Component {

    constructor() {
        super()

        this.state = {
            uid: "",
            round: "",
            visible: false,
            data: [],
            status: "loading",
            page: 1,
            count: 0,
        }
    }

    /* Open Action */
    open = (uid, round) => {

        /* Check */
        if (!uid || !round) {
            return
        }

        /* Open Modal */
        this.setState({ visible: true, uid, round }, () => {
            this.load()
        })

    }

    /* Load Action */
    load = (reload = false, page = 1) => {

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Set Page */
        this.setState({ page })

        /* Fields */
        const { uid, round } = this.state

        /* Send to REST API */
        refunds({ uid, round, page }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0, cnt: 0 })
        })
    }

    /* Close Action */
    close = () => {
        this.setState({
            uid: "",
            round: "",
            visible: false,
            data: [],
            status: "loading",
            page: 1,
            count: 0,
        })
    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { data, status } = this.state

        /* Layout */
        if (status !== "ok") {
            return <InnerLayout status={status} reload={() => this.load(true, 1)} />
        }

        return (
            <div className="refund-transactions--modal-content">

                <div className="refund-transactions--modal-item">
                    <div className="refund-transactions--modal-key head">#</div>
                    <div className="refund-transactions--modal-key head">{t("refund.transactionNumber")}</div>
                    <div className="refund-transactions--modal-key head">{t("refund.name")}</div>
                    <div className="refund-transactions--modal-key head">{t("refund.amount")}</div>
                    <div className="refund-transactions--modal-key head">{t("refund.amountUSD")}</div>
                    <div className="trefund-transactions--modal-key head">{t("widget.status")}</div>
                    <div className="refund-transactions--modal-key head">{t("refund.admin")}</div>
                    <div className="refund-transactions--modal-key head">{t("refund.dateTime")}</div>
                </div>

                {data.map((item, index) =>
                    <div className="refund-transactions--modal-item" key={`${index}`}>
                        <div className="refund-transactions--modal-key head">{index}</div>
                        <div className="refund-transactions--modal-key head">{utils.checkValue(item.number, "-")}</div>
                        <div className="refund-transactions--modal-key head">{utils.checkValue(item.reason, "-")}</div>
                        <div className="refund-transactions--modal-key head">{utils.convertor(item.total, item.symbol)}</div>
                        <div className="refund-transactions--modal-key head">{utils.convertor(item.totalUSD, "$")}</div>
                        <div className="trefund-transactions--modal-key head">
                            {parseInt(item.status) === 1 ? <div className="success">{t("refund.success")}</div> : null}
                            {parseInt(item.status) === 2 ? <div className="error">{t("refund.error")}</div> : null}
                        </div>
                        <div className="refund-transactions--modal-key head">{utils.checkValue(item.admin, "-")}</div>
                        <div className="refund-transactions--modal-key head">{moment(item.createdAt).format("HH:mm Do MMM YYYY")}</div>
                    </div>
                )}
            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, page, count } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="refund-transactions--modal"
                overlayClassName="refund-transactions--overlay"
                closeTimeoutMS={200}
            >

                <div className="refund-transactions--modal-header">
                    <h2>{t("refund.title")}</h2>
                    <div onClick={() => this.close()} className="refund-transactions--modal-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                {/* Draw Content */}
                {this._content()}

                <Pagination size={1} page={page} total={count} onPageChange={(page) => this.load(true, page)} />

            </Modal>
        )
    }
}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Refunds)